import styles from './../styles/section3.module.scss';
import lifestyle1 from '../img/lifestyle1.jpg';
import lifestyle2 from '../img/lifestyle2.jpg';
import lifestyle3 from '../img/lifestyle3.jpg';
import lifestyle4 from '../img/lifestyle4.jpg';
import lifestyle5 from '../img/lifestyle5.jpg';
import React from 'react';
import {
  Row,
  Col
} from 'reactstrap';

const Section3 = (props) => {
  return ( <
    div id = "lifestyle"
    className = {
      styles.rowSection + ' mx-0'
    } >
    <
    h1 className = {
      styles.textGray + ' ' + styles.textTitle + ' py-5 text-center'
    } >
    BALVANERA LIFESTYLE <
    /h1> <
    div className = {
      styles.imagenesLifestyle + ' d-lg-flex my-4 px-5 mx-center justify-content-center'
    } >
    <
    div className = {
      styles.hoverCard
    } >
    <
    img src = {
      lifestyle1
    }
    className = {
      styles.imgLifestyle + ' img-fluid w-100 lazyload'
    }
    alt = "lifestyle1" /
    >
    <
    div className = {
      styles.showCardOnHover
    } >
    <
    div className = "d-flex" >
    <
    div >
    <
    h1 className = "text-white" > POLO < /h1> <div className={styles.lineWhite}> </div >
    <
    /div> <
    /div> <
    /div> <
    /div> <
    div className = {
      styles.hoverCard
    } >
    <
    img src = {
      lifestyle2
    }
    className = {
      styles.imgLifestyle + ' img-fluid w-100 lazyload'
    }
    alt = "lifestyle2" /
    >
    <
    div className = {
      styles.showCardOnHover
    } >
    <
    div className = "d-flex" >
    <
    div >
    <
    h1 className = "text-white" > HÍPICO < /h1> <div className={styles.lineWhite}> </div >
    <
    /div> <
    /div> <
    /div> <
    /div> <
    div className = {
      styles.hoverCard
    } >
    <
    img src = {
      lifestyle3
    }
    className = {
      styles.imgLifestyle + ' img-fluid w-100 lazyload'
    }
    alt = "lifestyle3" /
    >
    <
    div className = {
      styles.showCardOnHover
    } >
    <
    div className = "d-flex" >
    <
    div >
    <
    h1 className = "text-white" > GOLF < /h1> <div className={styles.lineWhite}> </div >
    <
    /div> <
    /div> <
    /div> <
    /div> <
    div className = {
      styles.hoverCard
    } >
    <
    img src = {
      lifestyle4
    }
    className = {
      styles.imgLifestyle + ' img-fluid w-100 lazyload'
    }
    alt = "lifestyle4" /
    >
    <
    div className = {
      styles.showCardOnHover
    } >
    <
    div className = "d-flex" >
    <
    div >
    <
    h1 className = "text-white" > TENIS < /h1> <div className={styles.lineWhite}> </div >
    <
    /div> <
    /div> <
    /div> <
    /div> <
    div className = {
      styles.hoverCard
    } >
    <
    img src = {
      lifestyle5
    }
    className = {
      styles.imgLifestyle + ' img-fluid w-100 lazyload'
    }
    alt = "lifestyle5" /
    >
    <
    div className = {
      styles.showCardOnHover
    } >
    <
    div className = "d-flex" >
    <
    div >
    <
    h1 className = "text-white" > FÚTBOL < /h1> <div className={styles.lineWhite}> </div >
    <
    /div> <
    /div> <
    /div> <
    /div> <
    /div> <
    /div>
  );
};
export default Section3;